<script lang="ts">
	import { storeSearchedText, storeSearchModal } from '$lib/js/stores'
	import { t } from 'svelte-i18n-lingui'
	import { page } from '$app/state'
	import { goto } from '$app/navigation'

	function openSearch() {
		$storeSearchModal = true
		if (!page.url.searchParams.get('search')) {
			page.url.searchParams.set('search', $storeSearchedText)
			goto(page.url.href)
		}
	}
</script>

<button onclick={() => openSearch()}>
	<p>{$t`Search for a product...`}</p>
	<span class="button">
		<span class="icon icon-search"></span>
	</span>
</button>

<style lang="scss">
	button {
		height: 36px;
		font-size: 14px;
		width: 100%;
		border: none;
		background: var(--grey);
		color: var(--grey--b);
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			display: flex;
			align-items: center;
			width: 100%;
			text-align: left;
			height: 36px;
			padding-left: 12px;
			cursor: text;
		}

		span {
			&.icon {
				width: 36px;
				height: 36px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: var(--main);
				color: white;
				font-weight: 700;
			}
		}
	}
</style>
